import styled from 'styled-components';

export const Wrap = styled.div`
  width: 100%;
`;

export const WrapTab = styled.div`
  height: 230px;
  overflow-y: scroll;
  ul {
    list-style: none;
    padding: 0px;
  }

  li {
    cursor: pointer;
    padding: 20px ${p => p.theme.app.padding.vertical};
    height: 25px;
    width: 100%;
    display: flex;
    align-items: center;
  }

  li:hover {
    background: #f1f1f1;
  }

  ul .active {
    color: ${p => p.theme.colors.primary.main};
  }

  ul {
    display: flex;
    flex-direction: column;
  }

  ul button {
    background: #ffffff;
    border: none;
    text-align: start;
    padding: 20px ${p => p.theme.app.padding.vertical};
    height: 25px;
    width: 100%;
    display: flex;
    align-items: center;
  }

  ul button:hover {
    background: #f1f1f1;
  }
`;

export const WrapChoiceLocation = styled.div`
  width: 100%;
  height: 300px;
  position: absolute;
  z-index: 100;
  background: #fff;
  left: 0px;
  top: 0px;
  box-shadow: 0px 0px 6px #52525a;
`;

export const WrapSelect = styled.div<{
  selectOpen: boolean;
  height?: string;
}>`
  width: 100%;
  position: relative;
  display: block;

  .select {
    height: ${p => p.height};
    display: flex;
    align-items: center;
  }
  .ant-select-selector {
    height: ${p => p.height} !important;
    display: flex;
    align-items: center;
  }

  .ant-select-selection-search {
    display: flex;
    align-items: center;
  }
`;

export const WrapError = styled.div`
  line-height: 24px;
  color: red;
`;
